export const strings = {
    v15Name: "v1.x",
    v2MiniName: "v2 Mini",
    v2MiniDTCName: "v2 Mini DTC",
    issName: "Other",
};